import { Action } from '../actions/types'

const INITIAL_STATE = {
    loading: false,
    requests: {
        requestList: [],
        lastVisible: {},
        lastPage: false
    },
    users: {
        userList: [],
        lastVisible: {},
        lastPage: false
    },
    currentRequest: {},
    currentIndex: 0,
    diagnosis: {
        general: '',
        recommendations: '',
        images: []
    },
    error: {}
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case Action.ADMIN_LOADING: 
            return {
                ...state,
                loading: true,
                error: {}
            }
        case Action.ADMIN_INITIAL_REQUESTS:
            return {
                ...state,
                loading: false,
                requests: {
                    requestList: action.payload.list,
                    lastVisible: action.payload.lastVisible,
                    lastPage: action.payload.lastPage
                }
                
            }
        case Action.ADMIN_MORE_REQUESTS: 
            return {
                ...state,
                loading: false,
                requests: {
                    requestList: [ ...state.requests.requestList, ...action.payload.list],
                    lastVisible: action.payload.lastVisible,
                    lastPage: action.payload.lastPage
                }
                
            }
            case Action.ADMIN_INITIAL_USERS:
                return {
                    ...state,
                    loading: false,
                    users: {
                        userList: action.payload.list,
                        lastVisible: action.payload.lastVisible,
                        lastPage: action.payload.lastPage
                    }
                    
                }
            case Action.ADMIN_MORE_USERS: 
                return {
                    ...state,
                    loading: false,
                    users: {
                        userList: [ ...state.users.userList, ...action.payload.list],
                        lastVisible: action.payload.lastVisible,
                        lastPage: action.payload.lastPage
                    }
                    
                }
        case Action.ADMIN_CURRENT_REQUEST:
            //console.log("reducer: ", action.payload)
            return {
                ...state,
                currentRequest: state.requests.requestList[action.payload],
                currentIndex: action.payload,
                diagnosis: {
                    general: '',
                    recommendations: '',
                    images: []
                }

            }
        case Action.ADMIN_SET_DIAGNOSIS:
            
            return {
                ...state,
                diagnosis: {...state.diagnosis, [action.payload.name]: action.payload.event}
            }
        case Action.ADMIN_GET_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        default:
            return state
    }
}